<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row" >
        <div class="col-md-6">
          <chart-card :key='tls_team_costs_data' :chart-data="tls_team_costs_data.data"
                      :chart-options="tls_team_costs_data.options"
                      :responsive-options="tls_team_costs_data.responsiveOptions"
                      chart-type="Pie"
                      >
            <template slot="header">
              <h4 class="card-title">TLS Certificates Costs Breakdown</h4>
              <p class="card-category">Values in $ (2018 - 2020)</p>
            </template>
            <template slot="footer">
              <div class="legend">

              </div>
              <hr>
              <div class="stats">/
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
        <div class="col-md-6">
          <chart-card :key='tls_date_costs_data' :chart-data="tls_date_costs_data.data"
                      :chart-options="tls_date_costs_data.options"
                      :responsive-options="tls_date_costs_data.responsiveOptions"
                      chart-type="Bar"
                      >
            <template slot="header">
              <h4 class="card-title">TLS Costs per Team</h4>
              <p class="card-category">Values in $ (2018 - 2020)</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle" :style='{color: colors[0]}'></i> 2018
                <i class="fa fa-circle" :style='{color: colors[1]}'></i> 2019
                <i class="fa fa-circle" :style='{color: colors[2]}'></i> 2020

              </div>
              <hr>
              <div class="stats">/
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
      </div>
      <div class="row" >
        <div class="col-md-12 rotated-labels">
          <chart-card :key='tls_year_month_costs_data' :chart-data="tls_year_month_costs_data.data"
                      :chart-options="tls_year_month_costs_data.options"
                      :responsive-options="tls_year_month_costs_data.responsiveOptions"
                      chart-type="Line"
                      >
            <template slot="header">
              <h4 class="card-title">TLS Costs Histogram</h4>
              <p class="card-category">Values in $ (2018 - 2020)</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle" :style='{color: colors[1]}'></i> executed
                <i class="fa fa-circle" :style='{color: colors[0]}'></i> projected

              </div>

              <hr>
              <div class="stats">/
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'
  import main from 'src/main.js'
  import { colors, formatMoney, formatSimple } from 'src/globalVariables'
  import { setInterval } from 'timers';

  import commit_info from '@/commit_info.txt'

  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData()
      this.commit_info = commit_info
      var vm = this
      setInterval(function(){
        vm.loadData()
      },vm.refresh_minutes*60*1000)

    },
    methods: {
      loadData: function(){
        var today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
        console.log('refreshing...',)
        axios.all([
            axios.get('tls/transactions-team?access_token=' + this.accessToken + '&st_date=20180101&fn_date=20201231&dimension=team'),
            axios.get('tls/transactions-team?access_token=' + this.accessToken + '&st_date=20180101&fn_date=20201231&dimension=year&team=all'),
            axios.get('tls/transactions-team?access_token=' + this.accessToken + '&st_date=20180101&fn_date=20201231&dimension=year-month')

        ]).then(axios.spread((first, second, third) => {
            this.tls_team_costs = first.data;
            this.tls_date_costs = second.data;
            this.tls_year_month_costs = third.data;
            this.loading = false;
        }));

        return true
      },
      refresh_tls_team: function() {
        var labels = []
        var series1 = []
        var sum = function(a, b) { return a + b };

        if (this.tls_team_costs){
          this.tls_team_costs.forEach(function(v, i){
            labels.push(v['team'])
            series1.push(parseFloat(v['cost']))

          })
          this.tls_team_costs_data = {
            'data': {
              'labels': labels,
              'series': series1
            },
            'options': {
              'height': '320px',
              'tooltip':{
                'tooltipFnc': function(meta, value){
                  return(value)
                },

                tooltipOffset: {
                  x: 15,
                  y: 90
                },
                'appendToBody':false,
                'transformTooltipTextFnc': function(value) {
                  return ''+ formatMoney.format(value) +' (' + (value/series1.reduce(sum)*100).toFixed(0)+'%)'
                  }
              },
              'ctPointLabels':{
                'textAnchor': 'middle',
                'labelOffset': {
                  'x': 0,
                  'y': -10
                },
              },
            },
            'responsiveOptions': [
              ['screen and (min-width: 640px)', {
                chartPadding: 30,
                labelOffset: 130,
                labelDirection: 'explode',
              }],
              ['screen and (min-width: 1024px)', {
                labelOffset: 80,
                chartPadding: 20,
              }]

            ]
          }
        }
      },
      refresh_tls_date: function() {
        var labels = [] // years
        var teams = {}
        var years = {}
        var current_year = ''
        var allseries = []
        if (this.tls_date_costs){
          this.tls_date_costs.forEach(function(data, i){
            years[data['date']] = null
            teams[data['team']] = 0
          })

          labels = Object.assign([], Object.keys(teams))
          // console.log(labels)
          // creating cartesian product of year x team
          this.tls_date_costs.forEach(function(data, i){
            years[data['date']] = Object.assign({},teams)
          })

          this.tls_date_costs.forEach(function(data, i){
            years[data['date']][data['team']] = data['cost']
          })

          Object.keys(years).forEach(function(year,i){
            // console.log(years[year])
            var series = []
            Object.keys(years[year]).forEach(function(team,i){
              series.push(years[year][team])
            })
            allseries.push(series)

          })
          // console.log(allseries)

          this.tls_date_costs_data = {
            'data': {
              'labels': labels,
              'series': allseries
            },
            'options': {
              'stackBars': false,
              'seriesBarWidth': 10,
              'seriesBarDistance': 10,
              'axisX': {
                'showGrid': true
              },
              'height': '245px',
              'chartPadding': {
                'right': 50,
                'left': 50,
              },
              'tooltip':{
                'tooltipFnc': function(meta, value){
                  return(value)
                },

                tooltipOffset: {
                  x: 15,
                  y: 90
                },
                'appendToBody':false,
                'transformTooltipTextFnc': function(value) {
                  return ''+ formatMoney.format(value)
                  }
              },
              'ctPointLabels':{
                'textAnchor': 'middle',
                'labelOffset': {
                  'x': 0,
                  'y': -10
                },
              },
            },
            'responsiveOptions': [
              ['screen and (max-width: 640px)', {
                'seriesBarDistance': 20,
                'axisX': {
                  labelInterpolationFnc (value) {
                    return value[0]
                  }
                }
              }]
            ]
          }
        }
      },
      refresh_tls_year_month: function() {
        var labels = [] // year month
        var series = []
        var projected = []
        if (this.tls_year_month_costs){
          this.tls_year_month_costs.forEach(function(data, i){
            labels.push(data['date'])
            console.log('1',data['estimated'])
            if (data['estimated']==0){
              series.push(data['cost'])
            }
            projected.push(data['cost'])
          })
          this.tls_year_month_costs_data = {
            'data': {
              'labels': labels,
              'series': [projected,series]
            },
            'options': {
              height: '100%',
              'axisX': {
                'showGrid': true,
              },
              'chartPadding': {
                'right': 50,
                'left': 50,
                'top':0,
              },
              'tooltip':{
                'tooltipFnc': function(meta, value){
                  return(value)
                },

                tooltipOffset: {
                  x: 15,
                  y: 90
                },
                'appendToBody':false,
                'transformTooltipTextFnc': function(value) {
                  return ''+ formatMoney.format(value)
                  }
              },
            },
            'responsiveOptions': [
              ['screen and (max-width: 640px)', {
                'seriesBarDistance': 20,
                'axisX': {
                  labelInterpolationFnc (value) {
                    return value[0]
                  }
                }
              }]
            ]
          }
        }
      }
    },
    watch: {
      tls_team_costs:function(){
        this.refresh_tls_team()
      },
      tls_date_costs:function(){
        this.refresh_tls_date()
      },
      tls_year_month_costs:function(){
        this.refresh_tls_year_month()
      },
    },
    computed: {

    },
    data () {
      return {
        refresh_minutes: 30,
        last_update: '',
        colors: colors,
        tls_team_costs:{},
        tls_team_costs_data:{},
        tls_date_costs:{},
        tls_date_costs_data:{},
        tls_year_month_costs:{},
        tls_year_month_costs_data:{},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        accessToken: '',
      }
    }
  }
</script>
<style>

</style>
